<app-section-layout
  [dataForChart]="graphData"
  [itemTemplate]="commoditiesGraph"
></app-section-layout>

<ng-template
  #commoditiesGraph
  let-data="data"
  let-navInfo="navInfo"
  let-componentState="componentState"
  let-setComponentState="setComponentState"
>
  <app-com-spec-slide
    [data]="data"
    (currentUserSelectedData)="setComponentState($event)"
    [userData]="componentState"
  ></app-com-spec-slide>
</ng-template>
